module.exports = __webpack_public_path__ + "93a02d2f46b869dedf34e11d567711bc.png";


//////////////////
// WEBPACK FOOTER
// ./shared/components/Logo/assets/beige/efrdxv.png
// module id = 2388
// module chunks = 0